import getReturnUrl from './get-return-url.js';

const openLocalWallet = async (theapp, context) => {
	console.log('openLocalWallet called');

	let mvcmywidget = theapp.getMvcMyWidget();
	let start_conditions = theapp.getStartConditions();

	if (!start_conditions)
	return;
	
	let _currency = context.currency;
	let _card = context.currentcard;
	let _scheme = context.currentscheme;

	var base_uri = await theapp.getLocalWalletUrl();
	var uri;

	// open device wallet
	var carduuid = (_card ? _card.uuid : null);
	var currencyuuid = (_currency ? _currency.uuid : null);
	
	if (carduuid && currencyuuid) {
		// current card
		uri = base_uri + '?route=' + (start_conditions.local_wallet_route ? start_conditions.local_wallet_route : 'currencycard');

		uri += '&ring=' + (start_conditions.local_wallet_ring ? start_conditions.local_wallet_ring : '1'); //ring=1 device wallet

		uri += '&currencyuuid=' + currencyuuid;

		uri += '&carduuid=' + carduuid;
	}
	else {
		// all cards
		uri = base_uri + '?route=currencycards';
	}

	// specify return url to come back here
	let returnurl = getReturnUrl(theapp);

	if (returnurl)
	uri += '&returnurl=' + theapp.encodebase64(returnurl);

	// additional parameters
	if (start_conditions.local_wallet_params) {
		try {
			let arr = Object.entries(start_conditions.local_wallet_params);

			for (var i = 0; i < (arr ? arr.length : 0); i++) {
				uri += '&' + arr[i][0] + '=' + arr[i][1];
			}
		}
		catch(e) {
			console.log('exception in PayWidget.onLoadCard parsing start_conditions.remote_params_string: ' + e);
		}
		
	}

	var options = {};

	if (start_conditions.pop_up === true) {
		options.pop_up = true;
	}

	theapp.gotoUrl(uri, options);
}

export default openLocalWallet;